import React from "react";

export function RequestError({text= "Error loading data"}) {
    return (
        <h3>
            {text}
        </h3>
    )
}